import React from 'react';
import Header from "../Header/header"
import "../../component/styles/styles.scss";
import Footer from '../Footer/footer';


export default function Modulewrapper({ children }) {
    return (
        <>
            <Header />
            <section>{children}</section>
            <Footer />
        </>
    )
}
